

































import { defineComponent, ref, watch } from '@vue/composition-api';
import { useRouter } from '@ideavivat/vivat-2';
import PartOfDrawer from '@/components/Vivat/PartOfDrawer.vue';

import { moduleList } from '@/views/Report/Management/management-router';
import useAuth from '@/useAuth';

const Index = defineComponent({
  components: {
    PartOfDrawer,
  },
  setup() {
    const { me } = useAuth();
    const { hasPermission } = useAuth();

    function validateDisplay(moduleItem: any) {
      if (moduleItem.name === 'DeliveryIncomeByHub' && me.hub.hubType !== 'MAIN') return false;
      if (moduleItem.name === 'DeliveryTimeByHub' && me.hub.hubType !== 'MAIN') return false;
      return hasPermission(`report-analytic.${moduleItem.name}`);
    }

    return {
      me,
      validateDisplay,
      hasPermission,
      moduleList,
    };
  },
});

export default Index;
